import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login/login.component';
import { LoginGuard } from './login/login.Guard';
import { RegisterComponent } from './login/register/register.component';
import { RegisterinterComponent } from './login/registerinter/registerinter.component';
import { RecoverComponent } from './login/recover/recover.component';
import { ProjectDetailComponent } from './admin/project-detail/project-detail.component';
import { UserListComponent } from './admin/user-list/user-list.component';
import { UserDetailComponent } from './admin/user-detail/user-detail.component';
import { AdminGuard } from './admin/admin.Guard';
import { ProjectListComponent } from './admin/project-list/project-list.component';
import { NoContentComponent } from './no-content/no-content.component';
import { HoldComponent } from './hold/hold.component';
import { HoldGuard } from './hold/Hold.Guards';
import { CanvasRendererGuards } from './builder/canvas-renderer/canvas-renderer.Guards';
import { CanvasRendererComponent } from './builder/canvas-renderer/canvas-renderer.component';
import { GmapsRendererComponent } from './builder/gmaps-renderer/gmaps-renderer.component';
import { GmapsRendererGuards } from './builder/gmaps-renderer/gmaps-renderer.Guards';
import { UserDetailGuards } from './admin/user-detail/user-detail.guard';
import { ProjectDetailGuards } from './admin/project-detail/project-detail.guard';
import { ProjectListGuards } from './admin/project-list/project-list.guard';
import { LegaltextComponent } from './legaltext/legaltext.component';

export const routes: Routes = [
	{ path: '', component: LoginComponent, canActivate: [LoginGuard] },
	{ path: 'login', component: LoginComponent },
	{ path: 'legaltext', component: LegaltextComponent },
	{ path: 'register', component: RegisterComponent },
	{ path: 'registerinter', component: RegisterinterComponent },
    { path: 'hold', component: HoldComponent, canActivate: [HoldGuard] },
	{ path: 'recover', component: RecoverComponent },
	{ path: 'scheme', component: CanvasRendererComponent, canActivate: [CanvasRendererGuards], runGuardsAndResolvers: 'always' },
	{ path: 'satelite', component: GmapsRendererComponent, canActivate: [GmapsRendererGuards], runGuardsAndResolvers: 'always' },
	{ path: 'project-detail', component: ProjectDetailComponent, canActivate: [ProjectDetailGuards] },
	{ path: 'user-list', component: UserListComponent, canActivate: [AdminGuard] },
	{ path: 'user-profile', component: UserDetailComponent, canActivate: [UserDetailGuards] },
	{ path: 'user-profile/:id', component: UserDetailComponent, canActivate: [UserDetailGuards] },
	{ path: 'project-list', component: ProjectListComponent, data: { showMargin: false }, canActivate: [ProjectListGuards] },
	{ path: 'estimation-list', component: ProjectListComponent, data: { showMargin: true }, canActivate: [ProjectListGuards] },
	{ path: '**', component: NoContentComponent }
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],// ,  enableTracing: true })],
	exports: [RouterModule]
})

export class AppRoutingModule { }
